import { render } from "./TripSeats.vue?vue&type=template&id=2528f792"
import script from "./TripSeats.vue?vue&type=script&lang=js"
export * from "./TripSeats.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__